<template>
  <v-container class="incidencia-container" fluid>
    <v-row justify="center" class="mb-2">
      <v-col cols="12" class="text-center">
        <h2 class="page-title">Incidencias rápidas</h2>
      </v-col>
    </v-row>

    <!-- Fila 1 -->
    
    <v-row justify="center" class="button-row">
        <v-col cols="12" class="d-flex justify-center flex-wrap gap-3">
          <v-btn
            v-for="btn in fila1"
            :key="btn.value"
            :color="selected.fila1 === btn.value ? 'success' : 'secondary'"
            :disabled="!rowEnabled[1]"
            :prepend-icon="btn.icon"
            class="incidencia-btn"
            size="large"
            elevation="3"
            @click="selectFila1(btn.value)"
          >
            <v-icon left>{{btn.icon}}</v-icon>
            {{ btn.label }}
          </v-btn>
        </v-col>
    </v-row>

  <v-divider class="my-3" color="grey"/>  
  
  
    <!-- Fila 2 -->
    <v-row justify="center" class="button-row">
      <v-col cols="12" class="d-flex justify-center flex-wrap gap-3">
        <v-btn
          v-for="btn in fila2"
          :key="btn.value"
          :color="selected.fila2 === btn.value ? 'success' : 'secondary'"
          :disabled="!rowEnabled[2]"
          class="incidencia-btn"
          size="large"
          elevation="3"
          @click="selectFila2(btn.value)"
        >
         <v-icon left>{{btn.icon}}</v-icon>
          {{ btn.label }}
        </v-btn>
      </v-col>
    </v-row>

    <v-divider class="my-3" color="grey"/>  

    <!-- Fila 3 -->
    <v-row justify="center" class="button-row">
      <v-col cols="12" class="d-flex justify-center flex-wrap gap-3">
        <v-btn
          v-for="btn in fila3"
          :key="btn.value"
          :color="selected.fila3 === btn.value ? 'success' : 'secondary'"
          :disabled="!rowEnabled[3]"
          class="incidencia-btn"
          size="large"
          elevation="3"
          @click="selectFila3(btn.value)"
        >
        <v-icon left>{{btn.icon}}</v-icon>
          {{ btn.label }}
        </v-btn>
      </v-col>
    </v-row>

    <v-divider class="my-3" color="grey"/>  

    <!-- Fila 4 Guardar o limpiar -->
    
    <v-row justify="center" class="button-row">
      <v-sheet class="py-3 px-2 px-md-6 sticky-footer">
        <v-col cols="12" class="d-flex justify-center flex-wrap gap-3">
          <v-btn
            color="primary"
            :disabled="!rowEnabled[4]"
            class="btn-lg"
            size="large"
            elevation="3"
            @click="guardarIncidencia"
          >
          <v-icon left>mdi-content-save</v-icon>
            Guardar incidencia
             
          </v-btn>
          <v-btn
            color="secondary"
            :disabled="!rowEnabled[4]"
            class="btn-lg"
            size="large"
            elevation="3"
            @click="limpiar"
          >
          <v-icon left>mdi-broom</v-icon>
            Limpiar
          </v-btn>
        </v-col>
       </v-sheet>
    </v-row>
   

    <!-- Snackbar mensaje resultado -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="5000"
      color="success"
      location="bottom center"
      rounded="lg"
      elevation="6"
    >
      <v-icon start icon="mdi-check-circle" />
      <strong>Incidencia guardada:</strong>&nbsp;{{ snackbar.message }}
      <template #actions>
        <v-btn icon="mdi-close" variant="text" @click="snackbar.show = false" />
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import axios from "axios"
  import { mapState } from "vuex";
  // import router from '../router';

export default {
  name: 'IncidenciaRapida',
  computed:{
      ...mapState(['empId', 'perId', 'urlRaiz'])
  },
  data() {
    return {
      fila1: [
        { label: 'TPV',        value: 'TPV',        icon: 'mdi-cash-register' },
        { label: 'BALANZA',    value: 'BALANZA',    icon: 'mdi-scale-balance' },
        { label: 'COMERZZIA',  value: 'COMERZZIA',  icon: 'mdi-shopping'      },
        { label: 'IMPRESORAS', value: 'IMPRESORAS', icon: 'mdi-printer'       },
      ],
      fila2: [
        { label: 'MASTER', value: 'MASTER', icon: 'mdi-desktop-classic' },
        { label: 'TPV2',   value: 'TPV2', icon: 'mdi-desktop-classic'   },
        { label: 'TPV3',   value: 'TPV3', icon: 'mdi-desktop-classic'   },
        { label: 'OTRAS',  value: 'OTRAS', icon: 'mdi-desktop-classic'  },
      ],
      fila3: [
        { label: 'No enciende',  value: 'No enciende', icon: 'mdi-power-plug-off'  },
        { label: 'Funciona mal', value: 'Funciona mal', icon: 'mdi-close-circle-outline' },
      ],
      selected: {
        fila1: null,
        fila2: null,
        fila3: null,
      },
      rowEnabled: {
        1: true,
        2: false,
        3: false,
        4: false,
      },
      snackbar: {
        show: false,
        message: '',
      },
    }
  },

  methods: {
    selectFila1(value) {
      this.selected.fila1 = value
      this.selected.fila2 = null
      this.selected.fila3 = null
      this.rowEnabled[2] = true
      this.rowEnabled[3] = false
      this.rowEnabled[4] = false
    },

    selectFila2(value) {
      this.selected.fila2 = value
      this.selected.fila3 = null
      if (this.selected.fila1 === 'IMPRESORAS') {
        this.rowEnabled[3] = false
        this.rowEnabled[4] = true
      } else {
        this.rowEnabled[3] = true
        this.rowEnabled[4] = false
      }
    },

    selectFila3(value) {
      this.selected.fila3 = value
      this.rowEnabled[4] = true
    },
    guardarIncidencia() {
  const partes = [this.selected.fila1, this.selected.fila2, this.selected.fila3].filter(Boolean)
  const descripcion = partes.join(' ') + ' // ' + this.$store.state.nombreUsuario + ' // '

  // Calcular IncCatId según la selección de fila1
  let incCatId = null
  switch (this.selected.fila1) {
    case 'TPV':       incCatId = 25; break
    case 'BALANZA':   incCatId = 36; break
    case 'COMERZZIA': incCatId = 36; break
    case 'IMPRESORAS': incCatId = 36; break
  }

  // Construir el objeto incidencia
  const dir = this.$store.state.dir
  const incidencia = {
    IncId: 0,
    IncTmp: new Date(),
    DirId: dir != null ? dir.DirId : null,
    PerId: this.$store.state.perId,
    IncCatId: incCatId,
    PriorId: 1,
    IncDescrip: descripcion,
    IncHis: [],
    IncRespuesta: '',
  }

  const controllerParameters = {
    Action: 'SAVE_ENTITY',
    Inc: incidencia,
    EmpId: this.empId,
    IncHisPerId: this.perId,
    Desarrollo: this.$store.state.desarrollo,
    Adjuntos: []
  }

  const AuthToken = localStorage.getItem('token')
  axios({
    method: 'POST',
    url: this.urlRaiz + '/api/inc',
    data: JSON.stringify(controllerParameters),
    headers: { 'content-type': 'application/json', 'Authorization': AuthToken }
  })
  .then(result => {
    if (result.data.Success) {
      //this.snackbar.message = descripcion
      //this.snackbar.show = true
      alert("Incidencia guardada=> "+ descripcion)
      this.limpiar()
    } else {
      alert(result.data.Message)
    }
  })
  .catch(() => {
    alert('Error al guardar la incidencia.')
  })
},
/* 
    guardarIncidencia() {
      const partes = [this.selected.fila1, this.selected.fila2, this.selected.fila3].filter(Boolean)
      
      this.snackbar.message = partes.join(' ') + " // " + this.$store.state.nombreUsuario + " // "  
      
      this.snackbar.show = true

       var incidencia = { };

      // alert(partes.join(' ') + " // " + this.$store.state.nombreUsuario + " // "  )
    }, */

    limpiar() {
      this.selected.fila1 = null
      this.selected.fila2 = null
      this.selected.fila3 = null
      this.rowEnabled[1] = true
      this.rowEnabled[2] = false
      this.rowEnabled[3] = false
      this.rowEnabled[4] = false
      this.snackbar.show = false
    },
  },
}
</script>

<style scoped>
.incidencia-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 32px 16px;
}

.page-title {
  font-size: 1.6rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgb(var(--v-theme-primary));
  margin-bottom: 8px;
}

.button-row {
  margin-bottom: 16px;
}

.incidencia-btn {
  min-width: 160px;
  font-weight: 600;
  min-height:  84px;
  letter-spacing: 0.06em;
  font-size: 1.05rem;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.btn-lg {
  height: 52px !important;
  font-size: 1.05rem !important;
}

.incidencia-btn:not(:disabled):hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18) !important;
}

.gap-3 {
  gap: 12px;
}
</style>
